import { viVN_QrCodeInformation } from './information';
import { viVN_QrCodeManagement } from './management';

export const viVN_QrCode = {
  ...viVN_QrCodeInformation,
  ...viVN_QrCodeManagement
};
